import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    DateField,
    TextField,
} from 'react-admin';
import InstanceTitle from './InstanceTitle';

const InstanceShow = props => (
    <Show title={<InstanceTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <DateField source="last_materialized" />
            <DateField source="materialized_until" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

export default InstanceShow;